import React, { ReactElement, useState } from 'react';
import CustomDropdown from '../../Shared/DropDowns/CustomDropdown';
import GatedDropdownTargetButton from './GatedDropdownTargetButton';
import { t } from 'i18next';
import MultiSelectForm from '../../Shared/Forms/MultiSelectForm';
import { OptionType } from '../../Shared/DropDowns/MultipleSelectDropDown';
import { statusOptions as allStatusOptions } from '../../../helpers/BillSearchHelper';
import '../../Shared/Search/BillTableFilters.scss';

const JURISDICTION_NAMES: Record<string, string> = {
  il: 'Illinois',
  ng: 'Nigeria',
  za: 'South Africa',
};

const pilotTooltipByValue: Record<string, string> = Object.fromEntries(
  allStatusOptions
    .filter((o) => o.applicableOnlyToJurisdictions)
    .map((o) => {
      const names = o.applicableOnlyToJurisdictions!.map(
        (j) => JURISDICTION_NAMES[j] ?? j,
      );
      const list =
        names.length <= 1
          ? names[0]
          : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
      return [
        o.value,
        `This status is not yet available in all jurisdictions. It is currently supported in ${list} only. Coverage will continue to expand.`,
      ];
    }),
);

type BillStatusFilterDropdownProps = {
  status: string[];
  statusOptions?: OptionType<string>[];
  handleStatusFiltersChange: (updatedStatusFilters: string[]) => void;
};

const BillStatusFilterDropdown = (
  props: BillStatusFilterDropdownProps,
): ReactElement => {
  const { status, statusOptions, handleStatusFiltersChange } = props;

  const [showStatusFilter, setShowStatusFilter] = useState(false);

  const selectedStatusCount = statusOptions?.filter((statusOption) =>
    status.some((aStatus) => statusOption.value === aStatus),
  ).length;

  return (
    <div className="adv-filter filter bill-status">
      <CustomDropdown
        setShowDropdown={setShowStatusFilter}
        showDropdown={showStatusFilter}
        target={
          <GatedDropdownTargetButton
            isDisplayed={showStatusFilter}
            label={t('buttons.search.billStatus')}
            onClick={() => setShowStatusFilter(!showStatusFilter)}
            selectedCount={selectedStatusCount}
          ></GatedDropdownTargetButton>
        }
        width={250}
      >
        <div className="adv-search-selector">
          <MultiSelectForm
            currentSelection={status}
            options={(statusOptions ?? []).map((o) => ({
              ...o,
              tooltip: pilotTooltipByValue[o.value],
            }))}
            showClearAll
            showSelectAll
            showSelectButtonsBottom
            singleColumn
            updateSelection={handleStatusFiltersChange}
          />
        </div>
      </CustomDropdown>
    </div>
  );
};

export default BillStatusFilterDropdown;
